import {Component, Input, OnInit} from '@angular/core';
import {Card} from '../../../_models/card.model';
import {CrisisAlertService} from '../../services/crisis-alert.service';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})

export class DashboardCardComponent implements OnInit {
  @Input() card: Card;
  isActive = false;

  constructor(private crisisAlertService: CrisisAlertService
  ) {
  }

  ngOnInit() {
    this.crisisAlertService.specialityNameObs.subscribe(specialty => this.isActive = this.card.specialityName === specialty);
  }

  loadCases(specialityCode: string) {
    this.crisisAlertService.pushListTrigger('card');
    this.crisisAlertService.loadAlerts(specialityCode);
  }
}
